import { render, staticRenderFns } from "./HelpSlides.vue?vue&type=template&id=245cb49a&scoped=true&"
import script from "./HelpSlides.vue?vue&type=script&lang=js&"
export * from "./HelpSlides.vue?vue&type=script&lang=js&"
import style0 from "./HelpSlides.vue?vue&type=style&index=0&id=245cb49a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245cb49a",
  null
  
)

export default component.exports